import { useAtom } from 'jotai'

import { Button } from '@/components/ui/button'
import useColorModeValue from '@/hooks/useColorModeValue'
import useCustomMediaQuery from '@/hooks/useCustomMediaQuery'
import { isServerRespondingAtom } from '@/store/gigiChat/ChatAtom'

const SettingsTag = ({
    disabled,
    isActive,
    onClick,
    icon,
    label,
    dataTestid,
}: {
    disabled?: boolean
    isActive: boolean
    onClick: () => void
    icon: JSX.Element
    label: {
        mobile: string
        desktop: string
    }
    dataTestid?: string
}) => {
    const [isServerResponding] = useAtom(isServerRespondingAtom)
    const [isMobile] = useCustomMediaQuery()
    return (
        <Button
            variant="mainSettings"
            bg={useColorModeValue(isActive ? 'dark.700' : 'white', isActive ? 'white' : 'dark.700')}
            color={useColorModeValue(isActive ? 'white' : 'dark.700', isActive ? 'dark.700' : 'white')}
            disabled={isServerResponding || disabled}
            onClick={onClick}
            padding={['12px 10px', '12px 10px', '12px 20px', '12px 20px']}
            data-testid={dataTestid}
        >
            {isMobile ? (
                label.mobile
            ) : (
                <>
                    {icon}
                    {label.desktop}
                </>
            )}
        </Button>
    )
}

export default SettingsTag
